"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = void 0;
var icons = {
  advancedSearch: 'icon-SVG_AdvancedSearch',
  aircraftType: 'icon-SVG_AircraftType',
  airWaybill: 'icon-SVG_AirWaybill',
  alertBell: 'fas fa-bell',
  arrowDownFilled: 'icon-SVG_Down_Arrow_Filled',
  arrowDownOutlined: 'icon-SVG_Down_Arrow_Outlined',
  arrowLeft: 'fas fa-arrow-left',
  arrowRight: 'fas fa-arrow-right',
  arrowUpFilled: 'icon-SVG_Up_Arrow_Filled',
  arrowUpOutlined: 'icon-SVG_Up_Arrow_Outlined',
  asc: 'fas fa-sort-up',
  bag: 'icon-SVG_Bag',
  bagHot: 'icon-SVG_Bag_Hot',
  bagUncategorized: 'icon-uncategorized_bag',
  camera: 'fas fa-camera',
  caretDown: 'fas fa-caret-down',
  caretLeft: 'fas fa-caret-left',
  caretRight: 'fas fa-caret-right',
  caretUp: 'fas fa-caret-up',
  cargoPiece: 'icon-SVG_CargoPiece',
  carrier: 'icon-SVG_Carrier',
  check: 'fas fa-check',
  checkFilled: 'icon-SVG_Status_Good_Filled',
  checkOutlined: 'icon-SVG_Status_Good',
  chevronDown: 'fas fa-chevron-down',
  chevronLeft: 'fas fa-chevron-left',
  chevronRight: 'fas fa-chevron-right',
  chevronUp: 'fas fa-chevron-up',
  clock: 'far fa-clock',
  close: 'icon-SVG_X_Close',
  cog: 'fas fa-cog',
  comment: 'fas fa-comment',
  compress: 'fas fa-compress-alt',
  consignee: 'icon-SVG_Consignee',
  container: 'icon-SVG_Container',
  copy: 'icon-SVG_Copy',
  customs: 'icon-SVG_Customs',
  dash: 'icon-SVG_Target_Met',
  dashFilled: 'icon-SVG_Status_Unknown_Filled',
  dashOutlined: 'icon-SVG_Status_Unknown',
  date: 'far fa-calendar-alt',
  desc: 'fas fa-sort-down',
  devices: 'icon-SVG_Devices',
  diagnostics: 'icon-SVG_Diagnostics',
  download: 'fas fa-download',
  dragDrop: 'icon-SVG_drag-drop',
  duplicate: 'icon-SVG_Duplicate',
  edit: 'icon-SVG_Edit',
  ellipsisVertical: 'fas fa-ellipsis-v',
  engine: 'icon-SVG_Engine',
  equipment: 'icon-SVG_Equipment',
  expand: 'fas fa-expand-alt',
  "export": 'fas fa-upload',
  favorite: 'far fa-star',
  favoriteFilled: 'fas fa-star',
  filter: 'fas fa-filter',
  fin: 'icon-SVG_Fin',
  flightArrival: 'icon-SVG_Flight_Arrival',
  flightDeparture: 'icon-SVG_Flight_Departure',
  gate: 'icon-SVG_Gate',
  healthPlc: 'icon-SVG_Health_PLC',
  healthSystem: 'icon-SVG_Health_System',
  hide: 'icon-SVG_hide',
  home: 'icon-SVG_Home',
  hot: 'icon-SVG_Hot',
  info: 'icon-SVG_Info2',
  infoFilled: 'icon-SVG_Info',
  keyboard: 'far fa-keyboard',
  kpi: 'icon-kpi_icon',
  link: 'fas fa-external-link-alt',
  loaded: 'icon-SVG_Loaded',
  location: 'fas fa-map-marker-alt',
  mecBds: 'icon-SVG_MEC_BSD',
  menu: 'icon-SVG_Menu_System',
  minus: 'fas fa-minus',
  missed: 'icon-SVG_Missed',
  modeColdBag: 'icon-mode_coldbag',
  modeGoalMissedBag: 'icon-mode_goalmissedbag',
  modeHotBag: 'icon-mode_hotbag',
  modeMechanical: 'icon-mode_mechanical',
  modeOperational: 'icon-mode_operational',
  modeRejectedBag: 'icon-mode_rejectedbag',
  modeSecurity: 'icon-mode_security',
  modeSystem: 'icon-mode_system',
  mosaic: 'icon-SVG_Mosaic',
  passenger: 'icon-SVG_Passenger',
  pause: 'fas fa-pause',
  plane: 'icon-SVG_Flight',
  play: 'fas fa-play',
  plus: 'fas fa-plus',
  print: 'fas fa-print',
  questionFilled: 'icon-SVG_Question',
  questionOutlined: 'icon-SVG_question_mark',
  random: 'fas fa-random',
  redo: 'icon-SVG_Redo',
  refresh: 'fas fa-sync-alt',
  reports: 'icon-SVG_Reports',
  reset: 'fas fa-undo-alt',
  resetZoom: 'icon-zoom-ResetView',
  save: 'far fa-save',
  search: 'icon-SVG_Search',
  security: 'icon-SVG_Security',
  share: 'fas fa-share-square',
  shipper: 'icon-SVG_Shipper',
  smartConnect: 'icon-SVG_SmartConnect',
  smartDrop: 'icon-SVG_SmartDrop',
  smartNotify: 'icon-SVG_SmartNotify',
  smartPass: 'icon-SVG_SmartPass',
  smartShip: 'icon-SVG_SmartShip',
  smartSort: 'icon-SVG_SmartSort',
  smartSuite: 'icon-SVG_SmartSuite',
  smartSuiteAlt: 'icon-SVG_SmartSuiteAlt',
  smartTrack: 'icon-SVG_SmartTrack',
  smartVision: 'icon-SVG_SmartVision',
  sort: 'fas fa-sort',
  sorted: 'icon-SVG_Sorted',
  staged: 'icon-SVG_Staged',
  stats: 'icon-SVG_Graph',
  subscriptions: 'fas fa-envelope',
  target: 'icon-SVG_Target',
  toggleOff: 'icon-carrier_flight_toggleview_off',
  tools: 'icon-SVG_Settings_Tools',
  tracerRecord: 'icon-SVG_Ahl_File',
  transfer: 'fas fa-exchange-alt',
  trash: 'fas fa-trash-alt',
  undo: 'icon-SVG_Undo',
  user: 'icon-SVG_User',
  warningFilled: 'icon-SVG_Warning',
  warningOutlined: 'icon-SVG_Status_Warning',
  x: 'fas fa-times',
  xFilled: 'icon-SVG_Status_Bad'
};
exports.icons = icons;